import React from "react";
import { StyledInput, StyledInputWrapper } from "./styles";

interface InputProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  name: string;
  error: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  required = false,
  name,
  error,
}) => (
  <StyledInputWrapper>
    {label && <label>{label}</label>}
    <StyledInput
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
    />
    {error && <span className="error-message">❗ {error}</span>}
  </StyledInputWrapper>
);
